export default class arrays {
    constructor() {
      console.log('class arrays');
    }
}
  
export const for_each_in = (array, cb) => { 
    for(let i = 0; i < array.length; i++) {
        cb(array[i], i, array)
    }
}

export const map = (array, cb) => {
    const newArray = []
    for(let i = 0; i < array.length; i++) {
        newArray.push(cb(array[i], i, array))
    }
    return newArray
}

export const filter = (array, cb) => {
    const newArray = []
    for(let i = 0; i < array.length; i++) {
        const element = array[i]
        if (cb(element, i, array)) newArray.push(element)
    }
    return newArray
}